import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import { API_ENV } from '@/constant';

import modules from './modules';

Vue.use(Vuex);

const isProduction = process.env.NODE_ENV === 'production';
// const API_ENV = process.env.API_ENV;

// 开发环境
const debug = !isProduction ||
    // 打包 alpha , beta, abtest 几个环境进行测试时
    (isProduction && API_ENV !== 'release');

export default new Vuex.Store({
    ...modules,
    strict: debug,
    // store中使用的插件
    plugins: debug ? [createLogger()] : [],
});



// WEBPACK FOOTER //
// ./src/store/index.js